import quoteCreationTypeOptions from "@/common/const/quote/quoteCreationTypes.const";
import { ColumnsStrategy } from "@/common/types";
import { QuoteActions } from "@/components";
import QuoteCreationTypeTag from "@/components/Quotes/QuoteCreationType/QuoteCreationTypeTag";
import PickQuoteLineElement from "@/components/Quotes/SingleQuoteResults/PickQuoteLineElement";
import {
  DefaultHeadColumns,
  DefaultTextColumn,
  FilterSelect,
} from "@/components/TableComponents";
import RangeFilter from "@/components/TableComponents/Head/RangeFilter";

const eplQuoteResultsStrategy: ColumnsStrategy[] = [
  {
    label: "",
    name: "id",
    render: (_: number, record: any) => <PickQuoteLineElement data={record} />,
    headerClassName: "!bg-white !pb-3",
  },
  {
    label: <DefaultHeadColumns text="Provider" />,
    name: "price",
    render: (value: any, record: any) => (
      <div key={record.id}>{value.lastMileProvider}</div>
    ),
    headerClassName: "!bg-white !pb-3",
  },
  {
    label: (
      <RangeFilter
        fieldName="filters-bandWidth"
        title="Bandwidth"
        max={10000}
        min={0}
      />
    ),
    name: "price",
    render: (value: any, record: any) => (
      <div key={record.id}>{value.bandWidth} MBPS</div>
    ),
    headerClassName: "!bg-white !pb-[30px]",
  },
  {
    label: <DefaultHeadColumns text="Currency" key={"Currency"} />,
    name: "price",
    render: (value: any, record: any) => (
      <div key={record.id}>{value.targetCurrency}</div>
    ),
    headerClassName: "!bg-white !pb-3",
  },
  {
    label: (
      <RangeFilter
        fieldName="filters-targetOTC"
        title="OTC"
        max={100000}
        min={0}
      />
    ),
    name: "price",
    render: (value: any, record: any) => {
      return (
        <DefaultTextColumn
          labelClassName="text-primary"
          className="py-0 text-primary"
          text={
            value.targetOTC === null
              ? "0"
              : Number.parseFloat(value.targetOTC).toFixed(2)
          }
          key={[value.id, record.id, value.targetOTC].join("-")}
        />
      );
    },
    headerClassName: "!bg-white !pb-[30px]",
  },
  {
    label: (
      <RangeFilter
        fieldName="filters-targetMRC"
        title="MRC"
        max={100000}
        min={0}
      />
    ),
    name: "price",
    render: (value: any, record: any) => {
      return (
        <DefaultTextColumn
          labelClassName="text-primary"
          className="py-0 text-primary"
          text={
            value.targetMRC === null
              ? "0"
              : Number.parseFloat(value.targetMRC).toFixed(2)
          }
          key={[value.id, record.id, value.targetMRC].join("-")}
        />
      );
    },
    headerClassName: "!bg-white !pb-[30px]",
  },

  {
    label: (
      <RangeFilter
        fieldName="filters-contractTerm"
        title="Contract Terms"
        min={1}
        max={60}
      />
    ),
    name: "price",
    render: (value: any, record: any) => (
      <div key={record.id}>{value.contractTerm}</div>
    ),
    headerClassName: "!bg-white !pb-[30px]",
  },
  {
    label: (
      <FilterSelect
        fieldName="filters-quoteLineType"
        values={quoteCreationTypeOptions}
      />
    ),
    name: "quoteType",
    render: (value: "Firm" | "Budgetary", record: any) => (
      <QuoteCreationTypeTag quoteCreationType={value} key={record.id} />
    ),
    headerClassName: "!bg-white !pb-[22px]",
  },
  {
    label: "",
    name: "id",
    render: (_: number, record: any) => <QuoteActions quoteLine={record} />,
    headerClassName: "!bg-white !pb-3",
  },
];
const eplQuoteResultsStrategyWithoutFilters: ColumnsStrategy[] = [
  {
    label: "",
    name: "id",
    render: (_: number, record: any) => <PickQuoteLineElement data={record} />,
    headerClassName: "!bg-white !pb-3",
  },
  {
    label: <DefaultHeadColumns text="Provider" />,
    name: "price",
    render: (value: any, record: any) => (
      <div key={record.id}>{value.lastMileProvider}</div>
    ),
    headerClassName: "!bg-white !pb-3",
  },
  {
    label: <DefaultHeadColumns text="Bandwidth" />,
    name: "price",
    render: (value: any, record: any) => (
      <div key={record.id}>{value.bandWidth}</div>
    ),
    headerClassName: "!bg-white !pb-3 ",
  },
  {
    label: <DefaultHeadColumns text="Currency" key={"Currency"} />,
    name: "price",
    render: (value: any, record: any) => (
      <DefaultTextColumn
        text={value.targetCurrency}
        key={value.currency + record.id}
        className="py-0"
      />
    ),
    headerClassName: "!bg-white !pb-3",
  },
  {
    label: <DefaultHeadColumns text="OTC" key={"OTC"} />,
    name: "price",
    render: (value: any, record: any) => {
      return (
        <DefaultTextColumn
          labelClassName="text-primary"
          className="py-0 text-primary"
          text={
            value.targetOTC === null
              ? "0"
              : Number.parseFloat(value.targetOTC).toFixed(2)
          }
          key={[value.id, record.id, value.targetOTC].join("-")}
        />
      );
    },
    headerClassName: "!bg-white !pb-3 ",
  },
  {
    label: <DefaultHeadColumns text="MRC" key={"MRC"} />,
    name: "price",
    render: (value: any, record: any) => {
      return (
        <DefaultTextColumn
          labelClassName="text-primary"
          className="py-0 text-primary"
          text={
            value.targetMRC === null
              ? "0"
              : Number.parseFloat(value.targetMRC).toFixed(2)
          }
          key={[value.id, record.id, value.targetMRC].join("-")}
        />
      );
    },
    headerClassName: "!bg-white !pb-3 ",
  },
  {
    label: <DefaultHeadColumns text="Contract Terms" />,
    name: "price",
    render: (value: any, record: any) => (
      <div key={record.id}>{value.contractTerm}</div>
    ),
    headerClassName: "!bg-white !pb-3",
  },
  {
    label: <DefaultHeadColumns text="Quote Type" />,
    name: "quoteType",
    render: (value: "Firm" | "Budgetary", record: any) => (
      <QuoteCreationTypeTag quoteCreationType={value} key={record.id} />
    ),
    headerClassName: "!bg-white !pb-3",
  },
  {
    label: "",
    name: "id",
    render: (_: number, record: any) => <QuoteActions quoteLine={record} />,
    headerClassName: "!bg-white !pb-3",
  },
];
export { eplQuoteResultsStrategy, eplQuoteResultsStrategyWithoutFilters };
